module.exports = __webpack_public_path__ + "img/menu-plus.02d9f280.svg";